exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".borderless th{border:none}.inp-tries{display:inline-block;width:50px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-6ac6038f!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/App/protected/components/contacts/Contacts.vue
// module id = 595
// module chunks = 0